import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { FormRenderProps, FormSpy } from 'react-final-form';

import { VirtualizedTableItem } from 'services/virtualizedTable/types';

import SubmittingSection from 'components/SubmissionSection';
import VirtualizedTableItemFormFields from '../VirtualizedTableItemFormFields';
import {
    CREATE_MODAL_QUERY_STRING_PARAM,
    EDIT_MODAL_QUERY_STRING_PARAM
} from '../../constants';

interface Props extends FormRenderProps<VirtualizedTableItem> {
    isEditForm?: boolean;
}

export const VirtualizedTableItemFormComponent = (
    props: Props
): React.ReactElement => {
    const { handleSubmit, isEditForm } = props;
    return (
        <Form onSubmit={handleSubmit}>
            <Grid className="no-vertical-gutters">
                <FormSpy>
                    {(formProps): React.ReactElement => (
                        <VirtualizedTableItemFormFields
                            {...formProps}
                            isEditForm={isEditForm}
                        />
                    )}
                </FormSpy>
            </Grid>
            <SubmittingSection
                queryStringCancelButtonParam={{
                    params: {
                        [CREATE_MODAL_QUERY_STRING_PARAM]: undefined,
                        [EDIT_MODAL_QUERY_STRING_PARAM]: undefined
                    },
                    ignoreActive: true
                }}
            />
        </Form>
    );
};

export default VirtualizedTableItemFormComponent;
